import {
  Injectable,
} from '@angular/core';
import {
  Store,
} from '@ngrx/store';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  TravelerDetailsUIStore,
} from '@refx/shared-store';
import {
  CheckoutPaymentInformationFacts,
} from './checkout-payment-information.facts';
import {
  countryOfResidence,
} from './fact-factories/country-of-residence';

@Injectable()
export class CheckoutPaymentInformationFactsService extends FactsService<CheckoutPaymentInformationFacts> {
  public facts = {
    countryOfResidence: this.store.pipe(countryOfResidence())
  };

  constructor(rulesEngine: RulesEngineRunnerService, private readonly store: Store<TravelerDetailsUIStore>) {
    super(rulesEngine);
  }
}
